import baseSettings from './AppSettings.json';
import Helper from '../Common/Helper';
import { merge } from 'lodash';

export class SettingsProvider implements ISettingsProvider
{
    private _domain?: string;
    public get domain(): string
    {
        if (!this._domain)
        {
            const hostname = window.location.hostname.toLowerCase();
            if (hostname.startsWith('localhost'))
            {
                this._domain = 'fadxpoc.iconics.cloud';
            }
            else
            {
                const match = hostname.match(/^(https?:\/\/)?([^.]+)\.([^/]+)/i);
                const protocol = match?.[1] ?? '';
                const subDomain = match?.[2] ?? '';
                this._domain = match?.[3] ?? '';
            }
        }
        return this._domain;
    }

    public async getSettings(): Promise<IAppSettings>
    {
        let envSettings: Partial<IAppSettings>;
        switch (this.domain)
        {
            case 'fadxpoc.iconics.cloud':
                envSettings = (await import('./AppSettings.Dev.json')).default;
                break;
            default:
                envSettings = {};
                break;
        }

        const mergedSettings = merge(baseSettings, envSettings) as IAppSettings;
        const populatedSettings = JSON.parse(JSON.stringify(mergedSettings).replaceAll('{domain}', this.domain)) as IAppSettings;
        return populatedSettings;
    }
}

export interface ISettingsProvider
{
    getSettings(): Promise<IAppSettings>
}

export interface IAppSettings
{
    externalVersion: string;
    internalVersion: string;
    devMode: boolean;
    platformApi: string;
    dataApi: string;
    dataEntryApi: string;
}
